import { createAction } from '@reduxjs/toolkit';

export const toggleCrm = createAction('ToggleCrm');

export const toggleSidebar = createAction('ToggleSidebar');

export const toggleSidebarView = createAction('ToggleSidebarView');

export const showQuoteSummary = createAction<string>('QuoteShowQuoteSummary');

export const dismissQuoteSummary = createAction('QuoteDismissQuoteSummary');

export const setSelectedBaseCurrency = createAction<string>('SetSelectedBaseCurrency');
